import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(!localStorage.getItem("cookie-consent")); }, []);
  const decide = (v) => { localStorage.setItem("cookie-consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:w-[420px] z-[100] bg-[#0A192F] text-white rounded-xl shadow-2xl border border-white/10 p-5">
      <div className="flex items-start gap-3">
        <Cookie size={22} className="text-emerald-400 mt-0.5 shrink-0" />
        <div className="text-sm text-slate-300">
          Wir verwenden nur technisch notwendige Cookies, um die Anmeldung und den Betrieb der Plattform zu ermöglichen.
          Mehr dazu in unserer <Link to="/datenschutz" className="text-emerald-400 underline">Datenschutzerklärung</Link>.
        </div>
      </div>
      <div className="flex gap-2 mt-4 justify-end">
        <Button size="sm" variant="ghost" data-testid="cookie-decline" onClick={() => decide("essential")} className="text-slate-300 hover:text-white hover:bg-white/10">Nur notwendige</Button>
        <Button size="sm" data-testid="cookie-accept" onClick={() => decide("all")} className="bg-emerald-500 hover:bg-emerald-600 text-white">Akzeptieren</Button>
      </div>
    </div>
  );
}
